export function isLibraryOrganization(orgName) {
    if (!orgName) {
        return false;
    }

    return orgName === "LibraryOrganization";
}